export const selectCustomers = ({ customers: { get } }) => get;
export const selectCustomersCount = ({ customers: { getCount } }) => getCount;
export const selectDeletedSuccess = ({ customers: { deleteCustomer } }) => deleteCustomer;
export const selectOrders = ({ customers: { getOrders } }) => getOrders;
export const selectAddresses = ({ customers: { getAddresses } }) => getAddresses;
export const selectRates = ({ customers: { getRates } }) => getRates;
